const ParseDate = (newValue) => {
    let day = 0;
    let month = 0;
    let year = 0;
    if (newValue.includes("/")) {
        const values = newValue.trim().split("/");
        day = parseInt(values[0]);
        month = parseInt(values[1]) - 1;
        year = parseInt(values[2]);
        return new Date(year, month, day);
    }
    if (newValue.includes("-")) {
        const values = newValue.trim().split("-");
        year = parseInt(values[0]);
        day = parseInt(values[2]) - 1;
        month = parseInt(values[1]);
        return new Date(year, month, day);
    }
}

export default ParseDate;